import { useEffect } from 'react';

export default function useOutsideMultipleElClick(ref, handleClick) {
  useEffect(() => {
    const listener = event => {
      if (!ref) return;
      const activeRef = ref.find(r => r.current && r.current.contains(event.target));
      const id = activeRef ? activeRef.current.id : null;
      handleClick(id);
    };
    document.addEventListener('mousedown', listener);
    return () => {
      document.removeEventListener('mousedown', listener);
    };
  }, [ref, handleClick]);
}



// WEBPACK FOOTER //
// ./app/javascript/client/hooks/useOutsideMultipleElClick.js